import React from 'react';
import { cn } from '../../lib/utils';

export function IncompleteJourneyCallout({ title, headline, action, className }) {
  if (!headline) return null;

  return (
    <aside
      className={cn(
        'rounded-xl border border-amber-200 bg-[#F8F1E3] px-4 py-3.5 text-amber-950 shadow-sm',
        className
      )}
    >
      <p className="font-display text-[10px] font-bold uppercase tracking-[0.14em] text-amber-800">
        {title || 'Incomplete path'}
      </p>
      <p className="mt-1.5 text-sm font-semibold leading-snug">{headline}</p>
      {action ? <p className="mt-2 text-xs leading-snug text-amber-900/85">{action}</p> : null}
    </aside>
  );
}
